
"use client"
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Image from "next/image";

const photos = [
  "/pscr1.webp",
  "/pscr2.webp",
  "/pscr3.webp",
  "/pscr4.webp",
  "/pscr5.webp",
  "/pscr6.webp",
  "/pscr7.webp",
  "/pscr8.webp",
  "/pscr9.webp",
  "/remoteStarterOrder.png"
];

export default function PhotoScroll() {
  // changed code
  const [showModal, setShowModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const openModal = (index: number) => {
    setCurrentIndex(index);
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = "";
  };

  const prev = () => setCurrentIndex((i) => (i === 0 ? photos.length - 1 : i - 1));
  const next = () => setCurrentIndex((i) => (i + 1) % photos.length);

  useEffect(() => {
    if (!showModal) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showModal]);

  return (
    <div className="overflow-x-hidden py-10 bg-white">
      <h2 className="text-4xl font-semibold text-center mb-8 text-[#1C1C1C] hover:text-[#6BAF92]">Gallery</h2>
      <p className="text-2l  text-center mb-8 text-[#1C1C1C]"> Photos of various Starters installed wirh our kisan mithraa starters</p>
      <div className="relative w-full">
        <motion.div
          className="flex space-x-4"
          initial={{ x: 0 }}
          animate={{ x: -1000 }}
          transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        >
          {photos.map((src, index) => (
            // changed code: replace anchor with button that opens modal
            <div
              key={index}
              className="min-w-[200px] h-40 md:min-w-[300px] md:h-60 flex-shrink-0 overflow-hidden rounded-lg border border-gray-200 cursor-pointer"
            >
              <button
                onClick={() => openModal(index)}
                className="w-full h-full block text-left p-0 border-0 bg-transparent"
                aria-label={`Open gallery image ${index + 1}`}
              >
                <Image
                  src={src}
                  width={800}
                  height={600}
                  alt={`Gallery Image ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                />
              </button>
              <button className="mt-2 w-full text-center text-sm text-[#4ad66d] hover:text-[#5EA785] font-medium" onClick={() => openModal(index)}>
                
                View Gallery
                
              </button>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Modal (same-page gallery view) */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
          role="dialog"
          aria-modal="true"
        >
          <button
            onClick={closeModal}
            className="absolute top-4 right-2 z-60 text-white bg-black/30 rounded-full p-2 hover:bg-black/50"
            aria-label="Close gallery"
          >
            ✕
          </button>

          <div className="relative max-w-[90%] max-h-[90%] flex items-center">
            <button
              onClick={prev}
              className="hidden md:flex items-center justify-center absolute left-0 ml-2 h-12 w-10 text-white bg-black/30 rounded-md hover:bg-black/50"
              aria-label="Previous image"
            >
              ‹
            </button>

            <div className="mx-auto">
              <Image
                src={photos[currentIndex]}
                width={1400}
                height={900}
                alt={`Gallery Image ${currentIndex + 1}`}
                className="max-w-full max-h-[80vh] object-contain rounded-md"
              />
            </div>

            <button
              onClick={next}
              className="hidden md:flex items-center justify-center absolute right-0 mr-2 h-12 w-10 text-white bg-black/30 rounded-md hover:bg-black/100"
              aria-label="Next image"
            >
              ›
            </button>
          </div>
        </div>
        
      )}
    </div>
    
  );
}
